import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Michael Irigoyen
 * id 7A8E4735-E738-4ECE-8386-889694014C22
 * name instrument-triangle
 * version: 4.1.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/instrument-triangle.svg
 * tags
 * - Music 
 */
export const InstrumentTriangleIcon = createSvgIcon(<><path d="M11.5 2H10.5V6.2C10.4 6.3 10.3 6.3 10.2 6.5L2.1 20.7C1.8 21.3 2.2 22 2.9 22H16V20H4.8L11 9.2L16.7 19.2L18.4 18.2L11.8 6.4L11.5 6.1V2M21 6H20V18L19.5 22H21.5L21 18V6Z" /></>, 'InstrumentTriangleIcon');
export default InstrumentTriangleIcon